import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.dark,
    margin: `0.5rem ${theme.sidePanel.gutter}`,
    padding: '1rem',
    alignSelf: 'flex-start',
    ...theme.mixins.borderRadius(),
    ...theme.mixins.shadow(),
    '&[data-isme="1"]': {
      alignSelf: 'flex-end',
      backgroundColor: theme.palette.primary.main,
      color: `${theme.palette.secondary.main}!important`,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  userName: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '90%',
    color: theme.palette.primary.main,
    marginRight: '0.5rem',
    '&[data-isme="1"]': {
      color: `${theme.palette.secondary.main}!important`,
    },
  },
  date: {
    opacity: 0.75,
    fontSize: '90%',
  },
  message: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    marginBottom: 0,
  },
  menuButton: {
    bottom: '0.5em',
    marginLeft: '1rem',
  },
  menuIcon: {},
}));

ChatMessage.propTypes = {
  isMe: PropTypes.bool,
  message: PropTypes.object.isRequired,
};

export default function ChatMessage({ message, isMe }) {
  const classes = useStyles();

  const { payload, Date } = message;

  /* {message?.payload?.fileName && (
		<Grid item xs={12}>
			<Box
				style={{
					cursor: 'pointer',
					backgroundColor: theme.palette.secondary.primary,
					display: 'flex',
					flexDirection: 'row',
					flexGrow: 1,
					marginLeft: 7,
					justifyContent: 'flex-start',
					alignItems: 'center',
				}}
				onClick={async e => {
					const { url } = await downloadMessageFile(
						externalMeetingId,
						meetingId,
						message?.payload?.fileId
					)
					await downloadFile(message?.payload?.fileName, url)
				}}
			>
				<div>
					<CloudDownloadIcon />
				</div>

				<div style={{ marginLeft: 2 }}>{message?.payload?.fileName}</div>
			</Box>
		</Grid>
	)} */
  // <Typography>{message.payload.message}</Typography>

  return (
    <div className={classes.root} data-testid="message-box" data-isme={isMe ? 1 : 0}>
      <div className={classes.header}>
        <Typography className={classes.userName} data-isme={isMe ? 1 : 0}>
          {payload.name}
        </Typography>
        <Typography className={classes.date}>{moment(Date).format('h:mm A')}</Typography>
        {/* <IconButton className={classes.menuButton} aria-label="message options">
          <MoreHorizIcon className={classes.menuIcon} />
        </IconButton> */}
      </div>

      <p className={classes.message}>{payload.message}</p>
    </div>
  );
}
